export const DESELECT_ALL_PASSENGERS_FOR_DELETION =
  'DESELECT_ALL_PASSENGERS_FOR_DELETION'

export default () => ({
  type: DESELECT_ALL_PASSENGERS_FOR_DELETION,
})
